module.exports = __webpack_public_path__ + "img/icn_personsettings.e6dd4cdd.svg";